import RoleHome from '../RoleHome';

export default function SocialWorkerPage() {
  return (
    <RoleHome
      title="Social worker"
      description="Social work cases for assigned patients."
    />
  );
}
